import { makeStyles } from "@material-ui/core";
import { alpha } from "@material-ui/core/styles";

import theme from "@/theme";

// 一覧の番号と上部チップで共通。表示時だけ動かし、入力中は静止させる。
export const useCurrentStepMotionStyles = makeStyles(() => ({
  "@keyframes currentStepEnter": {
    "0%, 100%": { transform: "scale(1)" },
    "45%": { transform: "scale(1.08)" },
  },
  "@keyframes currentStepRing": {
    from: { boxShadow: `0 0 0 0 ${alpha(theme.palette.primary.main, 0.28)}` },
    to: { boxShadow: `0 0 0 7px ${alpha(theme.palette.primary.main, 0)}` },
  },
  current: {
    position: "relative",
    animation: "$currentStepEnter 420ms ease-out",
    "&::after": {
      content: "\"\"",
      position: "absolute",
      inset: 0,
      borderRadius: "inherit",
      pointerEvents: "none",
      animation: "$currentStepRing 1200ms ease-out 180ms 2",
    },
    "@media (prefers-reduced-motion: reduce)": {
      animation: "none",
      "&::after": { animation: "none" },
    },
  },
}));
